export class IdNameModel {
  public id: string = "";
  public name: string = "";
}
